import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum JobAssetsColumn {
  Index = 'Index',
  Asset = 'Asset',
  BatterySent = 'BatterySent',
  PowerCordSent = 'PowerCordSent',
  Warranty = 'Warranty',
  PmContract = 'PmContract',
  PmPreApproved = 'PmPreApproved',
  IsOwner = 'IsOwner',
  SerialNumber = 'SerialNumber',
  PoNumber = 'PoNumber',
  AssetNumber = 'AssetNumber',
  Accessories = 'Accessories',
  CustomerConcern = 'CustomerConcern',
  CorrectiveActions = 'CorrectiveActions',
  DeviceChecks = 'DeviceChecks',
}

export function constructAssetsColumns(
  assetColumnTmp: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: JobAssetsColumn.Asset,
      header: 'Asset',
      type: TableColumnType.Template,
      template: assetColumnTmp
    },
    {
      columnId: JobAssetsColumn.BatterySent,
      header: 'Battery',
      type: TableColumnType.Boolean
    },
    {
      columnId: JobAssetsColumn.PowerCordSent,
      header: 'Power Cord',
      type: TableColumnType.Boolean
    },
    {
      columnId: JobAssetsColumn.Warranty,
      header: 'Warranty',
      type: TableColumnType.Boolean
    },
    {
      columnId: JobAssetsColumn.PmPreApproved,
      header: 'PM Pre-approval',
      type: TableColumnType.Boolean
    },
    {
      columnId: JobAssetsColumn.PmContract,
      header: 'PM/Service Contract',
      type: TableColumnType.Boolean
    }
  ];
}
